import { useMutation } from "react-query";
import { Experience } from "types";
import { api } from "@/api/api";
import { getSeller } from "@/utils/getSeller";

export function usePreviewReviewTemplate(experience?: Experience, onSuccess?: () => void) {
    const seller = getSeller();

    return useMutation(
        async (customHTML: string | null) => {
            const { data } = await api.post<string>(`/sellers/${seller.id}/messages/preview`, {
                template: "purchase.reminder.review",
                experience: experience?.id,
                customHTML,
            });
            return data;
        },
        { onSuccess },
    );
}
